<template>
	<span v-if="hasError">
<!--		<div v-for="error in reducedErrors" class="alert" :class="errorClass(error)">{{ error.message }}<span
				v-show="error.count > 1" class="ml-1 badge badge-light">{{ error.count }}</span></div>-->
		<div v-for="(error, index) in reducedErrors">
			<b-alert fade dismissible :variant="error.type ? error.type.toLowerCase() : 'info'" :show="5" @dismissed="deleteError(index)">{{error.message}}</b-alert>
		</div>
	</span>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
	name: "FeedbackPanel",
	computed: {
		...mapGetters({
			errors: 'get_errors'
		}),
		reducedErrors: function () {
			return this.errors.reduce(function (acc, curr) {
				let found = acc.find(element => element.message === curr.message && element.type === curr.type);
				if (found) {
					found.count++
				} else {
					curr.count = 1;
					acc.push(curr)
				}
				return acc
			}, [])
		}
	},
	destroyed: function () {
		this.clearErrors()
	},
	methods: {
		...mapActions({
			clearErrors: 'clear_errors',
			deleteError: 'delete_error'
		}),
		hasError: function () {
			return this.errors.length > 0
		},
		errorClass: function (error) {
			if (error.type === 'SUCCESS') {
				return 'alert-success'
			} else if (error.type === 'WARNING') {
				return 'alert-warning'
			} else if (error.type === 'DANGER') {
				return 'alert-danger'
			}
		}
	}
}
</script>

<style scoped>

</style>